document.addEventListener("DOMContentLoaded", function () {
    const images = document.querySelectorAll(".lazy-img"); // Select only images within your blocks

    const observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    entry.target.setAttribute("loading", "lazy");
                    observer.unobserve(entry.target); // Stop observing once applied
                }
            });
        },
        { rootMargin: "0px 0px 0px 0px" }
    );

    images.forEach((img) => observer.observe(img));

    //SCRIPT GOOGLE

    // Initialize dataLayer and override push
    window.dataLayer = window.dataLayer || [];
    const originalPush = dataLayer.push.bind(dataLayer);

    dataLayer.push = function (event) {
        if (!hasConsent()) {
            saveEventToStorage(event);
        } else {
            originalPush(event);
        }
    };

    // Check consent status
    function hasConsent() {
        return localStorage.getItem("consent") === "granted";
    }

    // Save events to localStorage
    function saveEventToStorage(event) {
        const pendingEvents = JSON.parse(
            localStorage.getItem("pendingEvents") || "[]"
        );
        pendingEvents.push(event);
        localStorage.setItem("pendingEvents", JSON.stringify(pendingEvents));
    }

    // Grant consent and replay events
    function grantConsent() {
        localStorage.setItem("consent", "granted");
        const pendingEvents = JSON.parse(
            localStorage.getItem("pendingEvents") || "[]"
        );
        pendingEvents.forEach((event) => originalPush(event));
        localStorage.removeItem("pendingEvents");
    }

    // Replay on page load if consent exists
    if (hasConsent()) grantConsent();
});

document.body.addEventListener("event", function (event) {
    if (event.target.id === "grant") {
        grantConsent();
    }
});

/* <button id="grant">Allow Tracking</button> */
